import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash-es';

@Injectable()

@Pipe({
  name: 'orderBy',
  pure: true,
  standalone: true
})
export class OrderBy implements PipeTransform {
  transform<T>(
    input: readonly T[] | null | undefined,
    config: string | ((item: T) => unknown) | Array<string | ((item: T) => unknown)>,
    order: 'asc' | 'desc' | boolean = 'asc'
  ): T[] {
    if (!input) {
      return [];
    }

    return _.orderBy(input, config as any, order as any);
  }
}
